import type { CellDrillDownInfoTypes, MeasureDrillDownInfo } from "../../../../../../../../api/types/svTypes";
import type { DrillDownPage } from "../../../../store/types/drillDownPageState.types";
import { isMeasureDrillDownInfo, isMetricDrillDownInfo } from "./isMeasureDrillDownInfo";
import ExtensionLedgerTitle from "./ExtensionLedgerTitle";
import { getExtensionLedger } from "./ledger/extensionLedgers";
import LedgerTitle from "./LedgerTitle";
import PageTitle from "./PageTitle";
import PortfolioMonitoringTitle from "./PortfolioMonitoringTitle";

const PageTitleWrapper = ({ configuration, info }: { configuration: DrillDownPage; info: CellDrillDownInfoTypes }) => {
  if (configuration.onlyLedger) {
    return <LedgerTitle configuration={configuration} info={info as MeasureDrillDownInfo} />;
  }
  if (isMeasureDrillDownInfo(info)) {
    const extensionLedger = getExtensionLedger(info.table);
    if (extensionLedger !== undefined) {
      return <ExtensionLedgerTitle configuration={configuration} title={extensionLedger.pageTitle} />;
    }
    return <PageTitle configuration={configuration} info={info} />;
  }
  if (isMetricDrillDownInfo(info)) {
    return <PortfolioMonitoringTitle configuration={configuration} />;
  }
  return <>Unknown drill down info type</>;
};

export default PageTitleWrapper;
